import { render, staticRenderFns } from "./Fixo.vue?vue&type=template&id=c260532e"
import script from "./Fixo.vue?vue&type=script&lang=js"
export * from "./Fixo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports